import { takeLatest, all, takeEvery } from "redux-saga/effects";
import {
    GET_PRODUCTS, GET_PRODUCTS_LISTING, GET_PRODUCTS_BIDDING, GET_FEATURED_PRODUCTS, GET_CATEGORIES, GET_SUB_CATEGORIES, GET_PRODUCT_DETAILS, LOGOUT, LOGIN, REGISTER, REGISTER_PROCEED, FORGOT_PASSWORD, GET_FILTERED_PRODUCTS, FETCH_PRODUCT
    , FETCH_SUBCATEGORY_FIELDS, FETCH_CATEGORY_FIELDS, ADD_PRODUCT, GET_REGISTERED_USER_PROCEED, GET_USER_PRODUCTS_LISTING, UPDATE_PRODUCT,
} from "../actions/types";
import {
    handleGetProducts, handleGetProductsBidding, handleGetProductsListing, fetchProduct, handleGetUserProductsListing,
    handleAddProducts, handleUpdateProduct
} from "./products"
import { handleGetFeaturedProducts } from "./featuredProducts"
import { handleGetProductDetails } from "./productDetails";
import { login, logout, registered_proceed, forgotPasswordHandler, fetchRegisterUser } from "./user";
import { handleGetFilteredProducts } from "./filteredProducts";
import { fetchCategoryFields } from './category';
import { fetchSubCategoryfields } from './subCategory'

export function* watcherSaga() {
    yield all([
        takeEvery(GET_FEATURED_PRODUCTS, handleGetFeaturedProducts),
        takeEvery(GET_FILTERED_PRODUCTS, handleGetFilteredProducts),
        takeEvery(GET_PRODUCT_DETAILS, handleGetProductDetails),
        takeLatest(FETCH_PRODUCT, fetchProduct),
        takeEvery(GET_PRODUCTS, handleGetProducts),
        takeLatest(GET_PRODUCTS_LISTING, handleGetProductsListing),
        takeLatest(GET_USER_PRODUCTS_LISTING, handleGetUserProductsListing),


        takeLatest(GET_PRODUCTS_BIDDING, handleGetProductsBidding),
        takeLatest(ADD_PRODUCT, handleAddProducts),
        takeLatest(UPDATE_PRODUCT, handleUpdateProduct),
        takeLatest(GET_REGISTERED_USER_PROCEED, fetchRegisterUser),

        takeEvery(FETCH_SUBCATEGORY_FIELDS, fetchSubCategoryfields),
        takeEvery(FETCH_CATEGORY_FIELDS, fetchCategoryFields),


        takeLatest(LOGOUT, logout),
        takeLatest(LOGIN, login),

        takeLatest(REGISTER_PROCEED, registered_proceed),
        takeLatest(FORGOT_PASSWORD, forgotPasswordHandler),


    ])
}